"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _react = _interopRequireDefault(require("react"));

var _default = function _default(_ref) {
  var onClose = _ref.onClose,
      open = _ref.open,
      onFactoryReset = _ref.onFactoryReset;

  function handleDialogClose(action) {
    if (action === 'reset') {
      onFactoryReset();
    }

    onClose();
  }

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onClose: function onClose() {
      return handleDialogClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "alert-dialog-title"
  }, "Reset"), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
    id: "alert-dialog-description"
  }, "Are you sure you want to reset? This will restore the default configuration.")), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return handleDialogClose();
    },
    color: "primary"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return handleDialogClose('reset');
    },
    color: "primary",
    variant: "contained"
  }, "OK")));
};

exports.default = _default;